export const modalStyleWide = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    minWidth: 400,
    maxHeight: '80%',
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius: '12px',
    boxShadow: 24,
    p: 4,
    overflow: 'auto'
};